import { superAdminLayoutState } from '../state/superAdminLayoutState'
import { GET_FOOTER_TEXT } from '../actions/SuperAdminFooterAction'

export function superAdminLayoutReducer(state = superAdminLayoutState, action) {
    switch (action.type) {
        case GET_FOOTER_TEXT:
            return Object.assign({}, state, {
                footerText: action.text
            })
        default:
            return state;
    }
}
